import { Big } from 'big.js';
import { currencyMultiplierMapping } from './currencyMultiplierMapping';
export function getMajorToMinor(amount, currency) {
    const multiplier = currencyMultiplierMapping[currency] || 100;
    return Big(amount).times(multiplier).toNumber();
}
export function getMinorToMajor(amount, currency) {
    const multiplier = 1 / (currencyMultiplierMapping[currency] || 100);
    return Big(amount).times(multiplier).toNumber();
}
const flagExceptionsMap = {
    XPF: 'pf',
    XOF: 'sn',
    XAF: 'cf',
    XCD: 'ag',
};
export const getFlagNameFromCurrencyCode = (currencyCode) => {
    const exception = flagExceptionsMap[currencyCode];
    const flag = exception || currencyCode.toLowerCase().substring(0, 2);
    return `${flag}.svg`;
};
